var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "build-outline",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8465 16.3233C33.3297 16.8368 32.6307 17.125 31.9022 17.125C31.1736 17.125 30.4746 16.8368 29.9578 16.3233L27.6745 14.0399C27.1605 13.5232 26.872 12.824 26.872 12.0952C26.872 11.3663 27.1605 10.6671 27.6745 10.1504L32.8427 4.97953C32.853 4.96969 32.8606 4.95747 32.865 4.94397C32.8693 4.93046 32.8702 4.91609 32.8677 4.90213C32.8651 4.88818 32.8592 4.87507 32.8503 4.86398C32.8415 4.85289 32.83 4.84417 32.817 4.83859C29.4809 3.40859 25.1556 4.13734 22.4091 6.86414C19.7811 9.47234 19.6316 13.3954 20.5941 16.8191C20.7308 17.3058 20.7305 17.8208 20.5931 18.3072C20.4557 18.7937 20.1866 19.2328 19.8155 19.576L5.4983 32.6514C5.07588 33.0259 4.73454 33.4829 4.49525 33.9942C4.25596 34.5055 4.12378 35.0604 4.10684 35.6247C4.08991 36.1889 4.18856 36.7507 4.39675 37.2755C4.60494 37.8002 4.91826 38.2768 5.31744 38.676C5.71663 39.0752 6.19325 39.3885 6.71799 39.5967C7.24274 39.8049 7.80452 39.9035 8.3688 39.8866C8.93308 39.8697 9.48794 39.7375 9.99925 39.4982C10.5106 39.2589 10.9675 38.9176 11.342 38.4952L24.5644 24.1436C24.9032 23.7787 25.335 23.5129 25.8134 23.3747C26.2918 23.2365 26.7988 23.231 27.28 23.359C30.678 24.2691 34.5452 24.098 37.1388 21.538C39.9309 18.788 40.5333 13.9273 39.1798 11.1455C39.1737 11.1334 39.1648 11.1228 39.1538 11.1148C39.1429 11.1067 39.1302 11.1014 39.1167 11.0992C39.1033 11.097 39.0896 11.0981 39.0766 11.1023C39.0637 11.1064 39.0519 11.1136 39.0423 11.1232L33.8465 16.3233Z",
    stroke: "url(#paint0_linear_1248_1665)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25146 37.12C9.01086 37.12 9.62646 36.5044 9.62646 35.745C9.62646 34.9856 9.01086 34.37 8.25146 34.37C7.49207 34.37 6.87646 34.9856 6.87646 35.745C6.87646 36.5044 7.49207 37.12 8.25146 37.12Z",
    fill: "url(#paint1_linear_1248_1665)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_1665",
    x1: 17.151,
    y1: -3.46971,
    x2: 49.1991,
    y2: 10.0428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1248_1665",
    x1: 7.8795,
    y1: 33.7863,
    x2: 10.3435,
    y2: 34.8251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildOutline);
export default __webpack_public_path__ + "static/media/build-outline.c27e1e624e9e0d5d1ebc9552c64a41a5.svg";
export { ForwardRef as ReactComponent };